import { render } from "./BillingDistribution.vue?vue&type=template&id=05c82416"
import script from "./BillingDistribution.vue?vue&type=script&lang=js"
export * from "./BillingDistribution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__